const credentialHelpers = {};

credentialHelpers.hasVendorAndLocation = (props) => {
  return credentialHelpers.hasVendor(props) &&
    credentialHelpers.hasLocation(props);
}

credentialHelpers.hasVendor = (props) => {
  if (props.vendor.selected && props.vendor.selected.apikey) return true;
  else return false;
}

credentialHelpers.hasLocation = (props) => {
  if (props.location.selected && props.location.selected.apikey) return true;
  else return false;
}

export default credentialHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/Credentials.js
 **/